import { Tab } from "@headlessui/react";
import PropTypes from "prop-types";
import { SwiperSlide } from "swiper/react";

import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import PostItem from "components/molecules/PostItem";
import TabListNew from "components/molecules/TabListNew/index";
import Banner from "components/organisms/Banner";
import CardVirtualOffice from "components/organisms/CardVirtualOffice";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import PostSlider from "components/organisms/PostSlider";
import WhyChooseUs from "components/organisms/WhyChooseUs";

const Component = ({ posts, data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-569"
          title="Virtual Office"
          bgColor="bg-bbc-gradient-service"
          breadcrumbs={data?.banner?.breadcrumbs}
          leftContent={
            <p className="mb-6 text-center lg:mb-10 lg:text-left">
              We help you establish your virtual office overseas to lower
              overhead costs, place business presence and meet company
              registration requirements.
            </p>
          }
          leftClassName="relative lg:mt-0 lg:col-7"
          rightClassName=" lg:col-5 "
          rightContent={
            <Img
              src="/assets/images/offshore/virtual-office/banner-offshore-virtual_office.png"
              width={622}
              height={436}
              alt="virtual office service"
              priority={true}
              className="w-full "
              wrapper={{
                className: "bbc-banner-image-bottom-0",
              }}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          <Title
            text="Create your right business image"
            className="title-h2 mb-6 text-center capitalize text-bbc-brand-800 lg:mb-10 lg:text-left"
          />
          <div className="row items-center gap-y-7">
            <div className="col-12 text-base lg:col-4">
              <p className="mb-6 tracking-[0.25px]">
                Our virtual office packages give you the ability to easily and
                quickly lease an office in any of our locations throughout the
                world, enabling you to expand your presence with many options:
              </p>
              <ul className="mb-6 pl-3">
                <li className="relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']">
                  Mailing address
                </li>
                <li className="relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']">
                  Local telephone number/Phone handling
                </li>
                <li className="relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']">
                  Meeting room
                </li>
                <li className="relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']">
                  Mail forwarding
                </li>
                <li className="relative pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']">
                  Others
                </li>
              </ul>
              <p className="tracking-[0.25px]">
                Join online and get set up instantly with a virtual address and
                a local representative. With virtual offices in premier
                locations throughout the world, you can have the freedom to
                lease a workspace and work in the city of your choice – anywhere
                in the world!
              </p>
            </div>
            <div className="col-4 hidden lg:block">
              <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-yellow-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                <div className="border-b border-bbc-neutral-500 pb-8">
                  <Title
                    as="h3"
                    text="Premium Package"
                    className="text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-yellow-500"
                  />
                </div>
                <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                  <ul>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7 ">
                        Prestigious mailing address
                      </span>
                    </li>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">
                        Mail handling service
                      </span>
                    </li>
                    <li className="relative">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">
                        Local telephone number /Phone handling
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="pt-6">
                  <p className="mb-2 font-semibold">Additional services</p>
                  <ul>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Scan/fax</span>
                    </li>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Meeting room</span>
                    </li>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Mail forwarding</span>
                    </li>
                    <li className="relative">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Others</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-4 hidden lg:block">
              <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                <div className="border-b border-bbc-neutral-500 pb-8">
                  <Title
                    as="h3"
                    text="Basic Package"
                    className="text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-brand-500"
                  />
                </div>
                <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                  <ul>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">
                        Prestigious mailing address
                      </span>
                    </li>
                    <li className="relative">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">
                        Mail handling service
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="pt-6">
                  <p className="mb-2 font-semibold">Additional services</p>
                  <ul>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Scan/fax</span>
                    </li>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Meeting room</span>
                    </li>
                    <li className="relative mb-2">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Mail forwarding</span>
                    </li>
                    <li className="relative">
                      <FaCheck
                        className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                        size={12}
                      />
                      <span className="inline-block pl-7">Others</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="lg:hidden">
              <TabListNew
                data={["Premium", "Basic"]}
                tabListClass={{ othersClass: "mb-6" }}
              >
                <Tab.Panels>
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                  >
                    <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                      <div className="border-b border-bbc-neutral-500 pb-8">
                        <Title
                          as="h3"
                          text="Premium Package"
                          className="text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-yellow-500"
                        />
                      </div>
                      <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Prestigious mailing address
                            </span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail handling service
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Local telephone number /Phone handling
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="pt-6">
                        <p className="mb-2 font-semibold">
                          Additional services
                        </p>
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Scan/fax</span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Meeting room
                            </span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail forwarding
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-yellow-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Others</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Tab.Panel>
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                  >
                    <div className="rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                      <div className="border-b border-bbc-neutral-500 pb-8">
                        <Title
                          as="h3"
                          text="Basic Package"
                          className="text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-brand-500"
                        />
                      </div>
                      <div className="border-b border-bbc-neutral-500 pt-8 pb-6">
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Prestigious mailing address
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail handling service
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="pt-6">
                        <p className="mb-2 font-semibold">
                          Additional services
                        </p>
                        <ul>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Scan/fax</span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Meeting room
                            </span>
                          </li>
                          <li className="relative mb-2">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">
                              Mail forwarding
                            </span>
                          </li>
                          <li className="relative">
                            <FaCheck
                              className="absolute left-1.5 top-1.5 text-bbc-brand-300"
                              size={12}
                            />
                            <span className="inline-block pl-7">Others</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Tab.Panel>
                </Tab.Panels>
              </TabListNew>
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs
        title="Why choose our virtual office service"
        sectionClassName="bg-bbc-gradient-2 py-10 lg:py-20"
        data={data?.dataWhyChooseUs}
      />
      <HowItWorks data={data?.dataMakeItWork} className="mb-10 lg:mb-20">
        <Title className="text-center font-semibold capitalize lg:text-left">
          <span className="block text-3xl text-bbc-brand-800 lg:text-bbc-40px">
            Make it work
          </span>
          <span className="mt-4 block text-3xl text-bbc-brand-700 lg:leading-[44px]">
            in 4 easy steps
          </span>
        </Title>
      </HowItWorks>
      <section>
        <Img
          src={"/assets/images/offshore/virtual-office/wave_top-virtual.svg"}
          width="1920"
          height="100"
          className="w-full"
          wrapper={{ className: " w-full  hidden lg:block" }}
          alt="Wave top"
        />
        <div className="lg:bg-bbc-package">
          <div className="container lg:pt-20 lg:pb-10">
            <Title
              text="Establish your worldwide presence"
              className="title-h2 mb-3 text-center capitalize text-bbc-brand-800 lg:mb-7"
            />
            <CardVirtualOffice data={data?.dataCountry} />
            <div className="mt-2 text-center lg:mt-6">
              <Link
                href="/contact-us"
                className="inline-block rounded-full bg-bbc-primary px-6 py-2 font-bold tracking-[0.5px] text-white transition-all duration-200 hover:bg-bbc-brand-600"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
        <Img
          src={"/assets/images/offshore/virtual-office/wave_bottom-virtual.svg"}
          width="1920"
          height="100"
          className="w-full"
          wrapper={{ className: " w-full  hidden lg:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              // Description="Get to know more with frequently asked questions."
              data={data?.dataFaqs}
            />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <PostSlider thetitle="Industry News & Insights">
            {posts.length > 0 &&
              posts.map((item, index) => (
                <SwiperSlide key={index}>
                  <PostItem post={item} />
                </SwiperSlide>
              ))}
          </PostSlider>
        </div>
      </section>
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

Component.defaultProps = {
  data: {},
  posts: [],
};
